import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

/**
 * Properties expected by the storage unavailable modal component
 */
export interface IStorageUnavailableModalProps {
    onOk: () => void
}

/**
 * Component displays modal warning of storage being unavailable.
 * Forces load of dummy data.
 * @param {IStorageUnavailableModalProps} props properties requied by component
 */
function StorageUnavailableModalComponent(
    props: IStorageUnavailableModalProps
) {
    return (
        <Modal show={true}>
            <Modal.Header>
                <Modal.Title>Warning, Cannot Save</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Local storage is unavailable, you will not be able to save
                    your work. If saving <strong>isn't</strong> important to you
                    then click "OK" to load evaluation data.
                </p>
                <p>
                    Additionally any settings changes you make (such as focusing
                    a board) will not be remembered between visits.
                </p>
                <p>
                    If you would like to be able to save, please enable local
                    storage then reload the page.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={props.onOk}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default StorageUnavailableModalComponent
